<template>
	<div style="width: 1200px;margin-top: 20px">
		<Upload ref="upload" :show-upload-list="false" :on-success="handleSuccess" :on-format-error="handleFormatError"
			:on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" multiple :action="actionUrl">
			<Button icon="ios-cloud-upload-outline">上传附件</Button>
		</Upload>
		<Table border :columns="columns" :data="fileData">
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id" :data-index="index"
					@click="showImage(row.file_path)">预览</Button>
				<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id" :data-index="index" :data-filename="row.filename"
					@click="editFile">重命名</Button>
				<Button type="error" size="small" :data-id="row.id" @click="delFile"
					v-if="row.status !=1">删除</Button>
			</template>
		</Table>
		<Modal title="阅览图片" v-model="showModal" footer-hide width="650px">
			<img :src="modalImage" v-if="showModal" style="width: 100%">
		</Modal>
		<Modal title="编辑" v-model="editFileModal" >
			新名称
			<Input v-model="newFileName" placeholder="请输入新文件名" style="width: 300px" />
			<div slot="footer">
				<Button type="primary" @click="editFileSubmit">提交</Button>
				<Button type="default" @click="editFileModal = false">取消</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		addFile,
		getFileList,
		delFile
	} from "../../../api/client";
	import {
		getBalance
	} from "../../../api/finance";
	import MyUpload from '../../tool/Upload.vue';
	import {
		mapGetters,
		mapActions
	} from "vuex";
	export default {
		components: {
			MyUpload
		},
		props: ['client_id'],
		data() {
			return {
				columns: [{
						title: "附件名称",
						key: "filename",
						align: 'center'
					},
					{
						title: "附件大小",
						key: "size",
						align: 'center'
					},
					{
						title: "上传人",
						key: "username",
						align: 'center'
					},
					{
						title: "上传时间",
						key: "created_at",
						align: 'center'
					},
					{
						title: "操作",
						slot: "action",
						align: 'center'
					},
				],
				actionUrl: '',
				fileurl: '',
				filename: '',
				filesize: '',
				imgName: '',
				visible: false,
				uploadList: [],
				fileData: [],
				showModal:false,
				editFileModal:false,
				modalImage:'',
				newFileName:'',
				fileid:'',
			};
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		created() {
			this.actionUrl = 'https://record.jzgloan.com/app/api/uploadFile';
		},
		mounted() {
			this.getFileList();
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			mySearch() {
				this.getList();
			},
			showImage(image) {
				console.log(image)
				this.showModal = true
				this.modalImage = image
			},
			handleView(url) {
				this.imgName = url;
				this.visible = true;
			},
			handleSuccess(res, file) {
				this.fileurl = res.data.url
				this.filename = file.name
				this.filesize = file.size
				this.addFile();
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: 'The file format is incorrect',
					desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: 'Exceeding file size limit',
					desc: 'File  ' + file.name + ' is too large, no more than 2M.'
				});
			},
			async addFile() {
				let that = this;
				let data = {};
				data.token = this.token;
				data.fileurl = that.fileurl;
				data.filename = that.filename;
				data.filesize = that.filesize;
				data.client_id = that.client_id;
				let res = await addFile(that, data);
				if (res.code == 1) {
					that.$Message.success(res.msg);
					that.getFileList();
				}
			},
			async editFileSubmit(){
				let that = this;
				let data = {};
				data.token = this.token;
				data.filename = that.newFileName;
				data.id = that.fileid;
				let res = await addFile(that, data);
				if (res.code == 1) {
					that.$Message.success(res.msg);
					that.getFileList();
					that.editFileModal = false;
				}
			},
			async delFile(e){
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id
							}
							let res = await delFile(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getFileList();
							}
						}, 1000);
					}
				})				
			},
			// 编辑文件
			async editFile(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let filename = e.currentTarget.dataset.filename;
				that.newFileName = filename;
				that.fileid = id;
				this.editFileModal = true;
				console.log(e.currentTarget.dataset.filename)
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 20;
				if (!check) {
					this.$Notice.warning({
						title: '最多只能上传20张图片.'
					});
				}
				return check;
			},
			async getFileList() {
				let that = this;
				let data = {};
				data.token = this.token;
				data.client_id = that.client_id;
				let res = await getFileList(that, data);
				that.fileData = res.data.list;
			},
		},
	};
</script>

<style lang="less" scoped>

</style>